import { gql } from "@apollo/client"

export const AGGREGATE_OBJECT_TYPE = gql`
	query(
		$where: ObjectTypeWhereInput
		$orderBy: [ObjectTypeOrderByWithRelationInput]
		$cursor: ObjectTypeWhereUniqueInput
		$take: Int
		$skip: Int
	){
		aggregateObjectType(
			where: $where
			orderBy: $orderBy
			cursor: $cursor
			take: $take
			skip: $skip
		){
			_count{
				id
				createdAt
				updatedAt
				isVisible
				title
				_all
			}
			_min{
				id
				isVisible
				title
			}
			_max{
				id
				isVisible
				title
			}
		}
	}
`